<template>
	<div class="status-loading" v-show="loading">&nbsp;</div>

	<!-- CONTAINER -->
	<div class="container-fluid paper-wrap bevel tlbr">

		<!-- TOP BAR -->
		<div id="paper-top">
			<div class="row">
				<div class="col-sm-3 no-pad">

					<a class="navbar-brand logo-text" href="#">
						<img src="/static/img/header-logo.png" alt="The Australian Wine Research Institute" />
					</a>
				</div>

				<div class="col-sm-9 no-pad">

					<h1 class="page-title">
						{{ title || '' }}
						<span v-if="site.id && title">
							| {{ site.name }}
						</span>
						<span v-if="site.id && !title">
							{{ site.name }}
						</span>
					</h1>

				</div>
			</div>
		</div>
		<!-- END OF TOP BAR -->

		<div class="wrap-sidebar-content">

			<!-- SIDE MENU -->
			<navigation></navigation>
			<!-- END OF SIDE MENU -->

			<!-- CONTENT -->
			<div class="wrap-fluid" id="paper-bg">
				<router-view></router-view>
			</div>
			<!-- END OF CONTENT -->

		</div>

		<!-- FOOTER -->
		<div id="footer">
			<a href="http://www.awri.com.au/" target="_blank" class="copyright pull-left hidden-xs" style="padding-left: 25px">AWRI Home</a>
			<a href="http://www.awri.com.au/disclaimer/" target="_blank" class="copyright pull-left">Disclaimer</a>
			<a href="http://www.awri.com.au/privacy-policy/" target="_blank" class="copyright pull-left">Privacy Policy</a>
			<a href="http://www.awri.com.au/industry_support/winemaking_resources/wine_fermentation/awri-ferment-simulator/" target="_blank" class="copyright pull-left">Help and FAQs</a>
			<a v-if="authorized.access == 30" href="https://thewinecloud.com.au/Secure/Administrator/DashBoard.aspx" target="_blank" class="copyright pull-left visible-md-block visible-lg-block">WineCloud Home</a>
			<a v-else href="https://thewinecloud.com.au/Secure/Client/DashBoard.aspx" target="_blank" class="copyright pull-left visible-md-block visible-lg-block">WineCloud Home</a>
			<a href="http://www.awri.com.au/industry_support/helpdesk/" target="_blank" class="copyright pull-left visible-md-block visible-lg-block">AWRI Helpdesk</a>
			<div class="copyright">Copyright &copy; {{currentYear}} The Australian Wine Research Institute</div>
		</div>
		<!-- END OF FOOTER -->

	</div>
	<!-- END OF CONTAINER -->
</template>

<style>
	.status-loading {
		z-index: 99;
	}

	.popover-help {
		cursor: pointer;
		color: #666;
	}

	.popover-help:hover, .popover-help:focus {
		color: #666;
		text-decoration: none;
	}
</style>

<script>
	import Vue from 'vue'
	import Navigation from './navigation.vue'
	import { loading, site, title, authorized } from 'vx/getters'
	import { SimulatorSetup as SimulatorSetupActions, TankGroups as TankGroupActions, User as UserActions } from 'vx/actions'

	export default {
		components: {
			Navigation
		},

		vuex: {
			getters: {
				loading,
				site,
				title,
				authorized
			},
			actions: {
				getSimulator: SimulatorSetupActions.get,
				allTankGroups: TankGroupActions.all
			}
		},

		route: {
			data(transition) {
				this.transition = transition;

				if (this.site.id) {
					this.getSimulator(this.site.id).then(() => {
						this.loaded.push('simulator');
					});

					this.allTankGroups(this.site.id).then(() => {
						this.loaded.push('tank-groups');
					});
				} else {
					transition.next();
				}
			}
		},

		watch: {
			loaded() {
				if (this.loaded.length == 2) {
					this.transition.next();
				}
			}
		},

		data() {
			return {
				loaded: [],
				transition: null,
				currentYear: (new Date()).getFullYear()
			};
		},

		ready() {
			$('body').popover({
				selector: '.popover-help',
				html: true,
				container: 'body',
				trigger: 'focus'
			});

			$('body').tooltip({
				selector: '[data-toggle="tooltip"]',
				html: true,
				container: 'body',
				trigger: 'hover'
			});

			$('body').css({ 'overflow': 'visible' });

			// Box Hider
			$("[data-widget='remove']").click(function() {
				let box = $(this).parents(".box").first();

				box.slideUp();
			});

			// Box Collapse
			$("[data-widget='collapse']").click(function() {
				let box = $(this).parents(".box").first();

				let bf = box.find(".box-body, .box-footer");

				if (! box.hasClass("collapsed-box")) {
					box.addClass("collapsed-box");
					bf.slideUp();
				} else {
					box.removeClass("collapsed-box");
					bf.slideDown();
				}
			});

			// Scroll Menus
			$(".menu").slimscroll({
				height: "200px",
				alwaysVisible: true,
				size: "5px"
			}).css("width", "100%");

			// Tooltips
			$("[data-toggle='tooltip']").tooltip();

			// Side Bar Accordion and Tooltipster
			$(".side-bar").accordionze({
				accordionze: true,
				speed: 300,
				closedSign: '<b class="fa fa-caret-down"></b>',
				openedSign: '<b class="fa fa-caret-up"></b>'
			});

			$('.tooltip-tip').tooltipster({
				position: 'top-left',
				animation: 'slide',
				theme: '.tooltipster-shadow',
				delay: 1,
				offsetY: '-50px',
				offsetX: '-60px',
				onlyOne: true
			});

			$("#skin-select #toggle").on('click', event => {
				if (this.$route.hideNavigation === true) {
					$('.wrap-fluid').css({ marginLeft: 0 });
				} else if ($(event.target).hasClass('active')) {
					$(event.target).removeClass('active')

					$('#skin-select').css({"width":"200px"});
					$('.wrap-fluid').css({"width":"auto","margin-left":"200px",});
					$('#skin-select li').css({"text-align":"left"});
					$('#skin-select li span, .devider-title h3, ul.topnav h4, .side-dash, .noft-blue, .noft-purple-number, .noft-blue-number').css({"display":"inline-block", "float":"none"});
					$('.ul.topnav h4, .hide-min-toggle').css({"display":"none"});
					$('.tooltip-tip2').addClass('tooltipster-disable');
					$('.tooltip-tip').addClass('tooltipster-disable');
					$('.datepicker-wrap').css({"position":"absolute", "right":"300px"});
					$('.skin-part').css({"visibility":"visible"});
					$('#menu-showhide').css({"height":"auto", "margin":"-10px 0 0"});
					$('#skin-select li i').css({"top":"8px 0"});
					$('ul.topnav ul').css({"border-radius":"0", "padding":"15px 25px"});
					$('#menuwrapper').removeAttr('id');
				} else {
					$(event.target).addClass('active')

					$('#skin-select').css({"width":"50px"});
					$('.wrap-fluid').css({"width":"auto", "margin-left":"50px"});
					$('#skin-select li').css({"text-align":"right"});
					$('#skin-select li span, .devider-title h3, ul.topnav h4, .side-dash, .noft-blue, .noft-purple-number, .noft-blue-number').css({"display":"none"});
					$('.datepicker-wrap').css({"position":"absolute", "right":"84px"});
					$('.skin-part').css({"visibility":"visible"});
					$('.hide-min-toggle').css({"display":"block"});
					$('#menu-showhide').css({"height":"100vh", "margin":"40px 0 0"});
					$('#skin-select li i').css({"top":"0", "left":"-11px", "padding":"8px 0"});
					$('ul.topnav ul').css({"border-radius":"0", "padding":"5px 10px"});
					$('ul.topnav ul').removeAttr('style');
					$('#menuwrapper ul li ul').css({"display":"inline-grid!important"});
					$('.accordion-nav').removeAttr('class').addClass('topnav');
					$(".side-bar").attr("id","menuwrapper");
				}

				$(window).trigger('resize');
			});

			$("#skin-select #toggle").addClass('active').trigger('click');

			this.$watch('$route', route => {
				$("#skin-select #toggle").addClass('active').trigger('click');
			});
 		}
	};
</script>



// WEBPACK FOOTER //
// template.vue?609e7e68